export default __webpack_public_path__ + "static/media/ic_cross_icon.1de2125f.svg";